import React, { useEffect, useState, useRef } from "react";
import { Box, Grid, Card, CardContent, Typography, Modal, Snackbar } from "@material-ui/core";
import { RiFilter2Fill } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import { AiOutlineEye } from "react-icons/ai";
import { useSelector, shallowEqual } from "react-redux";
import { GetFilterJobSeeker, GetSaveFilter, SaveFilter, UpdateFilter } from "./api";
import { NavLink, useHistory, useLocation } from 'react-router-dom'
import MuiAlert from '@material-ui/lab/Alert';
import img1 from "./Vector (5).svg"
import { CSVLink } from 'react-csv' 
import Filter from "./Filter"; 

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function RowComponent({item}){
  return (
    <tr>
      <td>
        {item.name}
      </td>
      <td>{item.email}
      </td>
      <td>{item.phone}</td>
      <td>{item.stage}</td>
      <td>{item.occupationInterest}</td>
    </tr>
  );
}

const JobSeeker = () => {
  const [show, setShow] = useState(true);

  const { user } = useSelector(({ auth }) => auth, shallowEqual);
  const [pending, setPending] = useState(false);
  const [filter, setFilter] = useState({
    userId: user.id,
    type: "ORGANIZATION",
    organizationId: user.organization,
    coaches: [],
    jobseekers: [],
    activities: [],
    occupationInterest: [],
    stages: {},
    from: "",
    to: "",
    userDetails: []
  });
  useEffect(() => {
    console.log(filter, "filter");
  }, [filter]);
  const [savedFilter, setSavedFilter] = useState("");
  const [jobseekers, setJobSeekers] = useState([]);

  const childRef = useRef(null);

  const history = useHistory();
  const location = useLocation();

  const [filterApplied, setFilterApplied] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);

  const [currentFilter, setCurrentFilter] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [snackbar, setSnackbar] = useState(() => ({
    isOpen: false,
    message: '',
    type: 'success'
  }))

  const [saveReport, setSaveReport] = useState({
    pending: false,
    name: '',
    description: '',
    id: ''
  })

  const [total, setTotal] = useState(0);

  const handleFilter = async (payload) => {
    let obj = { ...filter, ...payload };
    console.log(obj, 'yes obj');
    if (obj.activities.length == 0 && obj.occupationInterest.length == 0 && Object.keys(obj.stages).length == 0 && (!obj.from || obj.from == '') && (obj.to == '' || !obj.to) && obj.coaches.length == 0 && obj.jobseekers.length == 0 && obj.userDetails.length == 0) {
      setSnackbar({
        isOpen: true,
        message: "No filter selected",
        type: 'error'
      })
      setFilterApplied(false);
      return;
    }
    setPending(true);
    setFilterApplied(true);
    try {
      console.log("handle", payload);
      let res = await GetFilterJobSeeker({ ...filter, ...payload });
      setFilter((pre) => {
        delete pre["save"];
        delete pre["name"];
        delete payload["save"];
        delete payload["name"];
        return { ...pre, ...payload };
      });
      setTotal(res.data.total)
      setJobSeekers(res.data.jobSeekers.map((item) => {
        let phone = "";
        if (item.cellPhone && item.cellPhone !== "0") {
          phone = item.cellPhone;
        }
        let lastSelectedStage = "";
        if (item.stages) {
          let stagesList = item.stages;
          Object.keys(stagesList).map((stages) => {
            if (typeof stagesList[stages] === "object") {
              Object.keys(stagesList[stages]).map((stage) => {
                if (stagesList[stages][stage]) {
                  lastSelectedStage = stage;
                }
              });
            }
            if (typeof stagesList[stages] === "boolean") {
              if (stagesList[stages]) {
                lastSelectedStage = stages;
              } else {
                if (!lastSelectedStage.length)
                  lastSelectedStage = "No stage selected";
              }
            }
          });
        } else {
          lastSelectedStage = "No stage selected";
        }
        let occupationInterest = '';
        if (item.occupationInterest) {
          occupationInterest = item.occupationInterest
        }
        if (occupationInterest == '') {
          occupationInterest = 'N/A'
        }
        if (lastSelectedStage == '' || lastSelectedStage == 'No stage selected') {
          lastSelectedStage = 'N/A';
        }
        return {
          _id: item._id,
          name: `${item.firstName} ${item.lastName}`,
          email: item.email,
          phone: phone || "N/A",
          stage: lastSelectedStage,
          occupationInterest: occupationInterest || 'N/A'
        }
      }));
    } catch (ex) {
      console.log(ex);
    } finally {
      setPending(false);
    }
  };
  useEffect(() => {
    console.log(filter.from && filter.from != "");
    if (
      filter.coaches.length > 0 ||
      filter.activities.length > 0 ||
      filter.occupationInterest.length > 0 ||
      Object.entries(filter.stages).length > 0 ||
      (filter.to && filter.to != "") ||
      (filter.from && filter.from != "")
    ) {
    } else {
      setSavedFilter("");
    }
  }, [filter]);
  // useEffect(() => {
  //   handleFilter(filter);
  // }, []);
  useEffect(() => {
    // alert('called')
    (async function () {
      setPageLoading(true);
      console.log(location, 'yomolopo');
      const searchParams = new URLSearchParams(location.search);
      console.log(searchParams.has('id'));
      if (location.state && location.state.filter) {
        setSaveReport({
          name: location.state.filter.name,
          description: location.state.filter.description,
          id: location.state.filter._id,
          pending: false
        })
        setCurrentFilter(location.state.filter.query)
        // childRef.current.handleApplyFilter(filter.data.query)
        setFilterApplied(true);
      } else if (searchParams.has('id')) {
        try {
          let filter = await GetSaveFilter(searchParams.get('id'));
          if (filter) {
            setSaveReport({
              name: filter.data.name,
              description: filter.data.description,
              id: filter.data._id,
              pending: false
            })
            console.log(childRef.current);
            setCurrentFilter(filter.data.query)

            // alert('yes')
            // childRef.current.handleApplyFilter(filter.data.query)
            // alert(JSON.stringify(filter));
            setFilterApplied(true);
          }
        } catch (ex) {

        }
      }
      setPageLoading(false);
      console.log(location);
    })();
  }, []);

  const handleChange = (e) => {
    e.persist();
    // console.log(e);
    setSaveReport((pre) => ({
      ...pre,
      [e.target.name]: e.target.value
    }))
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!saveReport.name || saveReport.name == '' || !saveReport.description || saveReport.description == '') {
      setSnackbar({
        isOpen: true,
        message: 'Please fill all fields',
        type: 'error'
      })
      return;
    }
    setSaveReport((pre) => ({
      ...pre,
      pending: true
    }))
    try {
      let obj = {
        ...filter,
        ...saveReport
      }
      if (saveReport.id && saveReport.id != '') {
        let res = await UpdateFilter(obj);
        setSnackbar({
          isOpen: true,
          message: res.message,
          type: 'success'
        })
        setSaveReport({
          description: '',
          name: '',
          pending: false
        })
      } else {
        let res = await SaveFilter(obj);
        setSnackbar({
          isOpen: true,
          message: res.message,
          type: 'success'
        })
        setSaveReport({
          description: res.data.description,
          name: res.data.name,
          pending: false,
          id: res.data._id
        })
        history.replace({
          pathname: location.pathname,
          search: `?id=${res.data._id}`
        })
      }
      // history.push({
      //   pathname: `/reportingoverview/report/${res.data._id}`,
      //   state: {id: res.data._id, filter: res.data}
      // })
      setIsModalOpen(false);
    } catch (ex) {
      console.log(ex);
      let error = ex.response ? ex.response.data.message : ex.message;
      setSnackbar({
        isOpen: true,
        message: error,
        type: 'error'
      })
    } finally {
      setSaveReport((pre) => ({
        ...pre,
        pending: false
      }))
    }

  }

  const CSVHeaders = [
    { label: 'name', key: 'name' },
    { label: 'email', key: 'email' },
    { label: 'phone', key: 'phone' },
    { label: 'stage', key: 'stage' },
    { label: 'occupationInterest', key: 'occupationInterest' },
  ];

  return (
    <Box>
      <Snackbar style={{ zIndex: 99999 }} open={snackbar.isOpen} autoHideDuration={6000} onClose={() => { setSnackbar((pre) => ({ ...pre, isOpen: false })) }}>
        <Alert onClose={() => { setSnackbar((pre) => ({ ...pre, isOpen: false })) }} severity={snackbar.type}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      {pageLoading ? <>
        <div className="w-100 d-flex align-items-center justify-content-between mb-2">
          <div
            class="spinner-border text-danger mx-auto"
            role="status"
          ></div>
        </div>
      </> : <>
        <div className="">
          <Filter
            savedFilter={setSavedFilter}
            handleFilter={handleFilter}
            setFilter={setFilter}
            show={show}
            setShow={setShow}
            type="ORGANIZATION"
            ref={childRef}
            currentFilter={currentFilter}
          />
          <div className=" d-flex flex-column">
            <h1 className="pb-5">Job-Seeker</h1>
            <div className="">
              <div className=" d-flex py-3">
                <RiFilter2Fill
                  className="  font"
                  onClick={() => setShow(false)}
                />
                <p className=" text-black font-weight-bold font1 mt-2">Filters</p>
                <p className="color mt-3 pl-5 ml-5">{savedFilter}</p>
              </div>
              <div className=" py-5">
                {filter.activities.length > 0 ||
                  filter.occupationInterest.length > 0 ||
                  Object.entries(filter.stages).length > 0 ||
                  (filter.to && filter.to != "") ||
                  (filter.from && filter.from != "") ||
                  filter.coaches.length > 0 ||
                  filter.jobseekers.length > 0 || filter.userDetails.length > 0 ? (
                  <>
                    {filter.activities.length > 0 &&
                      filter.activities.map((e, i) => {
                        return (
                          <button
                            key={i}
                            onClick={() => {
                              setFilter((pre) => ({
                                ...pre,
                                activities: filter.activities.filter(
                                  (ele) => ele != e
                                ),
                              }));
                              console.log(e);
                              handleFilter({
                                ...filter,
                                activities: filter.activities.filter(
                                  (ele) => ele != e
                                ),
                              });
                              childRef.current.handleClearActivities(filter.activities.filter(ele => ele != e))
                            }}
                            className="ml-3 rounded clr"
                          >
                            {e} <RxCross2 className="clr" />
                          </button>
                        );
                      })}
                    {filter.userDetails.length > 0 && filter.userDetails.map((e, i) => {
                      return <button key={i} onClick={() => {
                        setFilter((pre) => ({
                          ...pre,
                          userDetails: filter.userDetails.filter(ele => ele.value != e.value && ele.type != e.type)
                        }))
                        childRef.current.handleClearUserDetails(filter.userDetails.filter(ele => ele.value != e.value && ele.type != e.type))
                        console.log(e);
                        handleFilter({ ...filter, userDetails: filter.userDetails.filter(ele => ele.value != e.value && ele.type != e.type) })
                      }} className="ml-3 rounded clr">{e.label} ({e.type}) <RxCross2 className="clr" /></button>
                    })}
                    {filter.jobseekers.length > 0 && (
                      <button
                        onClick={() => {
                          setFilter((pre) => ({
                            ...pre,
                            jobseekers: [],
                          }));
                          handleFilter({ ...filter, jobseekers: [] });
                          childRef.current.handleClearJobseeker([])
                        }}
                        className="ml-3 rounded clr"
                      >
                        {`Jobseeker`} <RxCross2 className="clr" />
                      </button>
                    )}
                    {filter.occupationInterest.length > 0 &&
                      filter.occupationInterest.map((e, i) => {
                        return (
                          <button
                            key={i}
                            onClick={() => {
                              setFilter((pre) => ({
                                ...pre,
                                occupationInterest:
                                  filter.occupationInterest.filter(
                                    (ele) => ele != e
                                  ),
                              }));
                              console.log(e);
                              handleFilter({
                                ...filter,
                                occupationInterest:
                                  filter.occupationInterest.filter(
                                    (ele) => ele != e
                                  ),
                              });
                              childRef.current.handleClearOccupationInterest(filter.occupationInterest.filter(ele => ele != e))
                            }}
                            className="ml-3 rounded clr"
                          >
                            {e} <RxCross2 className="clr" />
                          </button>
                        );
                      })}

                    {Object.entries(filter.stages).length > 0 &&
                      Object.entries(filter.stages).map((stage, i) => {
                        return (
                          <button
                            key={i}
                            onClick={() => {
                              // console.log([filter.stages[stage[0]][key[0]]]);
                              setFilter((pre) => {
                                delete pre.stages[stage[0]];

                                return pre;
                              });
                              let temp = filter;
                              delete temp.stages[stage[0]];
                              handleFilter(temp);
                              childRef.current.handleClearStage(stage[0]);
                            }}
                            className="ml-3  rounded clr"
                          >
                            {stage[0]} <RxCross2 className="clr" />
                          </button>
                        );
                      })}
                    {filter.from && filter.from != "" && (
                      <button
                        onClick={() => {
                          setFilter((pre) => ({
                            ...pre,
                            from: "",
                          }));
                          handleFilter({ ...filter, from: "" });
                          childRef.current.handleClearFromDate()
                        }}
                        className="ml-3  rounded clr"
                      >
                        {filter.from} <RxCross2 className="clr" />
                      </button>
                    )}

                    {filter.to && filter.to != "" && (
                      <button
                        onClick={() => {
                          setFilter((pre) => ({
                            ...pre,
                            to: "",
                          }));
                          handleFilter({ ...filter, to: "" });
                          childRef.current.handleClearToDate()
                        }}
                        className="ml-3  rounded clr"
                      >
                        {filter.to} <RxCross2 className="clr" />
                      </button>
                    )}
                    <button
                      onClick={() => {
                        setFilter((pre) => ({
                          ...pre,
                          activities: [],
                          occupationInterest: [],
                          stages: {},
                          from: "",
                          to: "",
                          jobseekers: [],
                          userDetails: []
                        }));
                        setSavedFilter("");
                        handleFilter({
                          ...filter,
                          activities: [],
                          occupationInterest: [],
                          stages: {},
                          from: "",
                          to: "",
                          jobseekers: [],
                          userDetails: []
                        });
                        childRef.current.handleClearFilter();
                      }}
                      className="ml-3 bg-transparent border-0 text1"
                    >
                      Clear All
                    </button>
                  </>
                ) : null}
              </div>
            </div>
          </div>

          {filterApplied && <div className=" d-flex" style={{ borderRadius: "4px", width: "158px", height: "78px", backgroundColor: "#FFFFFF", boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.13)" }}>
            <div className="" style={{ width: "54px", backgroundColor: "rgba(55, 131, 231, 0.1)", height: "54px", marginTop: "12px", marginLeft: "16px", borderRadius: "4px" }}>
              <img style={{ margin: "13px" }} src={img1} alt="email" />
            </div>
            <div style={{ marginLeft: "16px" }}>
              <h1 style={{ marginTop: "12px", color: "rgba(26, 32, 64, 0.75)", fontSize: "12px", fontWeight: "500", lineHeight: "18px", }}>Job Seeker</h1>
              <h1 style={{ marginTop: "-10px", color: "#3783E7", fontSize: "24px", fontWeight: "700", lineHeight: "36px", }}>{total}</h1>
            </div>

          </div> }
          {!filterApplied && <div><h1 className=" text-center ptop">No Applied Filter</h1></div>}

          {filterApplied && <div className="pb-5 mt-5 rounded-sm shadow-lg ">
            <div className="pt-5 pb-5 pr-4 d-flex justify-content-end">
              <CSVLink
                data={jobseekers}
                target="_blank"
                className="bg-transparent border-0 text"
                headers={CSVHeaders}
                filename={`report_${new Date().getTime()}.csv`}
                onClick={() => {
                  if (pending) {
                    setSnackbar({
                      isOpen: true,
                      message: 'Fetching data',
                      type: 'error'
                    })
                    return false;
                  }
                  if (!filterApplied) {
                    setSnackbar({
                      isOpen: true,
                      message: 'Please apply filter',
                      type: 'error'
                    })
                    return false;
                  }
                  if (jobseekers.length == 0) {
                    setSnackbar({
                      isOpen: true,
                      message: 'No data available',
                      type: 'error'
                    })
                    return false;
                  }
                }}
              >
                CSV Export
              </CSVLink>
              <button
                type="button"
                onClick={() => {
                  // history.push('/reportingoverview/report')
                  setIsModalOpen(true);
                }}
                className="rounded-sm px-5 py-2 border-0  btn_color text-white ml-3"
              >
                {saveReport.id ? "Update Report" : "Save Report"}
              </button>
            </div>
            <table class="table ">
              <thead className="">
                <tr className="text-center">
                  <th scope="col">Client Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Phone</th>
                  <th scope="col">Stage</th>
                  <th scope="col">Occupation Interest</th>
                </tr>
              </thead>
              <tbody className="text-center">
                {pending ? (
                  <tr>
                    <td colSpan={8}>
                      <div className="w-100 d-flex align-items-center justify-content-between mb-2">
                        <div
                          class="spinner-border text-danger mx-auto"
                          role="status"
                        ></div>
                      </div>
                    </td>
                  </tr>
                ) : jobseekers.length == 0 ? (
                  <>
                    {" "}
                    <tr>
                      <td colSpan={8}> No Jobseeker Found </td>
                    </tr>{" "}
                  </>
                ) : (
                  jobseekers.map((item, index) => {
                    return <RowComponent key={index} item={item} />
                  })
                )}
              </tbody>
            </table>
          </div>}

        </div>
        <Modal
          open={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
          }}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          BackdropProps={{ onClick: () => { } }}
        >
          <div className='w-25 left top1  bg-white rounded-lg overflow-hidden pb-5  main1'>
            <div className='Abg-c d-flex justify-content-between align-items-start px-5 '>
              <div className='  pt-5'>
                <h1 className='font3'>{saveReport.id ? 'Update Report' : "Save Report"}</h1>
                <p>For Future Use.</p>
              </div>
              <button disabled={saveReport.pending} onClick={() => { setIsModalOpen(false) }} className='bg-transparent border-0 btnSize icon  pt-2'><RxCross2 /></button>
            </div>

            <div className="container mt-5  px-5" >

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-12 mt-5">

                    <label htmlFor="" className='font-weight-bold'>Title</label>
                    {/* <div className='form-control' name='title' value={form.title} onChange={handleChange} type="text" placeholder='Product Designer|'>Product Designer|</div> */}
                    <input className='form-control' name='name' value={saveReport.name} onChange={handleChange} type="text" placeholder='Title' />

                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mt-5">

                    <label htmlFor="" className='font-weight-bold'>Description</label>
                    {/* <div className='form-control' name='title' value={form.title} onChange={handleChange} type="text" placeholder='Product Designer|'>Product Designer|</div> */}
                    <textarea className='form-control' name='description' value={saveReport.description} onChange={handleChange} type="text" placeholder='Title'></textarea>

                  </div>
                </div>
                <div className="row">
                  <div className="col-12 mt-5 d-flex justify-content-center">
                    {/* <button type='submit' className='form_btn bg-transparent' disabled={form.pending}> */}
                    {/* Save as draft */}
                    {/* { form.pending ? <div class="spinner-border text-white mx-auto" role="status"></div> : 'Submit' } */}
                    {/* </button> */}
                    <button disabled={saveReport.pending} className='btn_color text-white border-0 py-3 px-5 form_btn form_btn1'>{saveReport.pending ? <div style={{ color: '#3783E7' }} class="spinner-border mx-auto" role="status"></div> : 'Submit'}</button>
                  </div>
                </div>
              </form>

            </div>

          </div>

        </Modal>
      </>}
    </Box>
  );
};

export default JobSeeker;
